<svg
  width="28"
  height="28"
  viewBox="0 0 28 28"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.0422 5.45998C8.95509 5.54852 8.88898 5.65524 8.83376 5.77223L8.82754 5.76591L0.104263 25.7386L0.112818 25.7473C-0.0489546 26.0659 0.221703 26.7141 0.776241 27.2785C1.33078 27.8422 1.96854 28.1173 2.28197 27.9528L2.28975 27.9607L21.9405 19.0937L21.9342 19.0866C22.0486 19.0313 22.1536 18.9641 22.2414 18.874C23.4563 17.6392 21.4862 13.6353 17.8425 9.93104C14.1971 6.22677 10.2578 4.22522 9.0422 5.45998Z"
    fill="#FFD74F"
  />
  <path
    d="M10.1108 9.02673L0.323589 25.2367L0.104263 25.7387L0.112818 25.7474C-0.0489546 26.0659 0.221703 26.7141 0.776241 27.2786C0.95668 27.462 1.14412 27.6011 1.32767 27.7189L13.2218 12.9792L10.1108 9.02673Z"
    fill="#E2B723"
  />
  <path
    d="M17.8981 9.86939C21.5302 13.5626 23.5469 17.4993 22.4005 18.6629C21.2549 19.8281 17.3817 17.7791 13.7472 14.0875C10.1144 10.3943 8.09843 6.45602 9.24406 5.29161C10.3905 4.12721 14.2637 6.17618 17.8981 9.86939Z"
    fill="url(#paint0_linear_16113_13305)"
  />
  <path
    d="M14.458 10.2986C14.3033 10.4259 14.101 10.4923 13.8872 10.4686C13.2121 10.3943 12.6443 10.1555 12.2469 9.77847C11.8261 9.37927 11.6184 8.84331 11.6752 8.30656C11.7748 7.36428 12.705 6.49948 14.2908 6.67339C14.9076 6.74058 15.1829 6.539 15.1922 6.44256C15.2031 6.34691 14.9768 6.09 14.36 6.02202C13.6849 5.94771 13.1172 5.70898 12.719 5.33191C12.2982 4.93271 12.0898 4.39675 12.1473 3.86C12.2484 2.91773 13.1778 2.05292 14.7621 2.22762C15.2117 2.27663 15.4489 2.18257 15.5492 2.1217C15.6293 2.0719 15.6612 2.02447 15.6643 1.9968C15.6737 1.90115 15.4504 1.64424 14.8321 1.57625C14.4051 1.52882 14.0956 1.1399 14.143 0.705123C14.1889 0.271139 14.5708 -0.042689 14.9993 0.00474089C16.5836 0.17786 17.3116 1.22369 17.2113 2.16676C17.1102 3.11061 16.1807 3.97384 14.5949 3.80072C14.1454 3.75091 13.9105 3.84577 13.8094 3.90664C13.7293 3.95565 13.6966 4.00387 13.6935 4.03075C13.6834 4.12719 13.9082 4.38331 14.5265 4.4513C16.1107 4.62521 16.8387 5.67025 16.7384 6.61331C16.6381 7.55559 15.7086 8.42039 14.1236 8.24569C13.674 8.19668 13.4376 8.29154 13.3365 8.35162C13.2556 8.40221 13.2245 8.44964 13.2214 8.47652C13.2113 8.57217 13.4361 8.82908 14.0536 8.89706C14.4798 8.94449 14.7901 9.33421 14.7427 9.76819C14.7209 9.98479 14.6128 10.1721 14.458 10.2986Z"
    fill="#266AF6"
  />
  <path
    d="M23.8464 17.6091C25.3809 17.1688 26.4395 17.8645 26.6915 18.7775C26.9435 19.6897 26.3975 20.8446 24.8637 21.2834C24.2649 21.4541 24.0852 21.745 24.1093 21.8375C24.1358 21.9308 24.4399 22.0842 25.0372 21.9126C26.5709 21.4739 27.6294 22.1695 27.8814 23.0818C28.135 23.9948 27.5874 25.1481 26.0529 25.5876C25.4548 25.7584 25.2744 26.0501 25.3008 26.1426C25.3265 26.2351 25.6298 26.3884 26.2279 26.2177C26.6401 26.0999 27.071 26.3441 27.1869 26.7639C27.302 27.1844 27.0617 27.6208 26.6479 27.7394C25.115 28.1781 24.0557 27.484 23.8021 26.5702C23.5501 25.658 24.0969 24.5047 25.6322 24.0651C26.231 23.8936 26.4107 23.6035 26.3842 23.5102C26.3594 23.4177 26.056 23.2636 25.4587 23.4343C23.9234 23.8738 22.8657 23.1798 22.6129 22.2652C22.3602 21.3529 22.9069 20.1996 24.4414 19.7593C25.0387 19.5893 25.2184 19.2969 25.1935 19.2052C25.1671 19.1119 24.8645 18.9585 24.2664 19.1293C23.8527 19.2478 23.4241 19.0028 23.3075 18.583C23.1916 18.1641 23.4327 17.7277 23.8464 17.6091Z"
    fill="#EA4F76"
  />
  <path
    d="M17.8888 15.4772C17.6601 15.4772 17.4345 15.3752 17.2806 15.1807C17.0122 14.8392 17.0674 14.342 17.4019 14.0693C17.5714 13.931 21.6157 10.7026 27.3315 11.5334C27.7569 11.595 28.0524 11.995 27.9918 12.4274C27.9311 12.859 27.5407 13.1626 27.1113 13.0978C22.0614 12.3689 18.4106 15.2748 18.3748 15.3041C18.2302 15.4211 18.0591 15.4772 17.8888 15.4772Z"
    fill="#EA4F76"
  />
  <path
    d="M4.47543 12.1887C4.40155 12.1887 4.32611 12.1776 4.25144 12.1555C3.84001 12.0298 3.60668 11.5895 3.73035 11.1713C4.61154 8.18876 5.41029 3.42916 4.42877 2.18808C4.31911 2.04737 4.15345 1.90904 3.7739 1.93828C3.04437 1.9952 3.11359 3.5596 3.11437 3.57541C3.14703 4.01097 2.82504 4.39041 2.39728 4.42282C1.96252 4.4497 1.59542 4.12876 1.56353 3.69319C1.48342 2.60309 1.81708 0.503529 3.65724 0.362029C4.47855 0.298789 5.16063 0.588902 5.64206 1.19759C7.48612 3.53035 5.61406 10.2931 5.22052 11.6258C5.11941 11.9681 4.80987 12.1887 4.47543 12.1887Z"
    fill="#266AF6"
  />
  <path
    d="M19.8326 8.23618C20.477 8.23618 20.9993 7.7053 20.9993 7.05043C20.9993 6.39556 20.477 5.86469 19.8326 5.86469C19.1883 5.86469 18.666 6.39556 18.666 7.05043C18.666 7.7053 19.1883 8.23618 19.8326 8.23618Z"
    fill="#FFD74F"
  />
  <path
    d="M1.55551 15.3507C2.41459 15.3507 3.11101 14.6429 3.11101 13.7697C3.11101 12.8966 2.41459 12.1887 1.55551 12.1887C0.696424 12.1887 0 12.8966 0 13.7697C0 14.6429 0.696424 15.3507 1.55551 15.3507Z"
    fill="#EA4F76"
  />
  <path
    d="M25.277 16.1412C25.9213 16.1412 26.4436 15.6103 26.4436 14.9555C26.4436 14.3006 25.9213 13.7697 25.277 13.7697C24.6327 13.7697 24.1104 14.3006 24.1104 14.9555C24.1104 15.6103 24.6327 16.1412 25.277 16.1412Z"
    fill="#EA4F76"
  />
  <path
    d="M18.277 25.6272C18.9213 25.6272 19.4436 25.0963 19.4436 24.4414C19.4436 23.7866 18.9213 23.2557 18.277 23.2557C17.6327 23.2557 17.1104 23.7866 17.1104 24.4414C17.1104 25.0963 17.6327 25.6272 18.277 25.6272Z"
    fill="#EA4F76"
  />
  <path
    d="M21.7772 4.2837C22.6363 4.2837 23.3327 3.57586 23.3327 2.7027C23.3327 1.82954 22.6363 1.1217 21.7772 1.1217C20.9181 1.1217 20.2217 1.82954 20.2217 2.7027C20.2217 3.57586 20.9181 4.2837 21.7772 4.2837Z"
    fill="#266AF6"
  />
  <path
    d="M25.277 7.44571C25.9213 7.44571 26.4436 6.91484 26.4436 6.25997C26.4436 5.6051 25.9213 5.07422 25.277 5.07422C24.6327 5.07422 24.1104 5.6051 24.1104 6.25997C24.1104 6.91484 24.6327 7.44571 25.277 7.44571Z"
    fill="#266AF6"
  />
  <path
    d="M22.944 10.6077C23.5883 10.6077 24.1106 10.0768 24.1106 9.42195C24.1106 8.76708 23.5883 8.23621 22.944 8.23621C22.2997 8.23621 21.7773 8.76708 21.7773 9.42195C21.7773 10.0768 22.2997 10.6077 22.944 10.6077Z"
    fill="#266AF6"
  />
  <path
    d="M5.83362 19.3032C6.47793 19.3032 7.00025 18.7723 7.00025 18.1174C7.00025 17.4626 6.47793 16.9317 5.83362 16.9317C5.18931 16.9317 4.66699 17.4626 4.66699 18.1174C4.66699 18.7723 5.18931 19.3032 5.83362 19.3032Z"
    fill="#FFCC4D"
  />
  <defs>
    <linearGradient
      id="paint0_linear_16113_13305"
      x1="15.8224"
      y1="4.96515"
      x2="15.8224"
      y2="18.9897"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D7B339" />
      <stop offset="1" stop-color="#977F2D" />
    </linearGradient>
  </defs>
</svg>
